import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=00dbdd20&scoped=true"
import script from "./user-manage.vue?vue&type=script&lang=js"
export * from "./user-manage.vue?vue&type=script&lang=js"
import style0 from "./user-manage.vue?vue&type=style&index=0&id=00dbdd20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dbdd20",
  null
  
)

export default component.exports